import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, Form, Select } from "antd";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  activeUser,
  showAuthLoader,
  userSignUp,
} from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "../components/CircularProgress/index";
import ReCAPTCHA from "react-google-recaptcha";
import { ShowError, ShowSmallError } from "../util/MessageHelper";
import { getData } from "../util/DynamicApi";
const FormItem = Form.Item;

const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};


const SignUp = (props) => {
  const dispatch = useDispatch();
  const [isAgent, setAgent] = useState(false);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const onFinish = (values) => {
    if (!values.isAccept || values.isAccept === false) {
      ShowError("قوانین سامانه", "لطفا قوانین سامامانه را تایید نمایید");
      return;
    }
    values.MobileNumber = "0098" + values.MobileNumber
    values.State = selectedState;
    values.City = selectedCity;
    dispatch(showAuthLoader());
    dispatch(userSignUp(values));
  };
  const onFinishToken = (values) => {
    dispatch(showAuthLoader());
    dispatch(activeUser(values));
  };
  const handleStateChange = (e, data) => {
    setSelectedState(e);
    getData(null, `register/providers/${data.key}/cities`).then((city) => {
      city.data.data.map((item, index) => {
        children.push(<Option key={item.name.toString()} value={item.name}>{item.name}</Option>);
      })
      setCity(children);
    })
      .catch((error) => {
        ShowSmallError(error.message);
      });
  }
  const handleCityChange = (e, data) => {
    setSelectedCity(e);
  }
  const {
    isActive,
    authUser,
    loader,
    token,
    alertMessage,
    showMessage,
  } = useSelector(({ auth }) => {
    return auth;
  });
  useEffect(() => {
    if (isActive == true && authUser !== null) {
      props.history.push("/SignIn");
    }
  });

  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const children = [];
  useEffect(() => {
    getData(null, 'Register/GetProvider').then((states) => {
      states.data.map((item, index) => {
        children.push(<Option key={item.providerId.toString()} value={item.name}>{item.name}</Option>);
      })
      setState(children);
    })
      .catch((error) => {
        ShowSmallError(error.message);
      });

  }, []);

  const Option = Select.Option;


  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img
                src={require("../../src/assets/images/back.jpg").default}
                alt="Neature"
              />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signUp" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src="/assets/images/logo.png" />
            </div>
          </div>
          {authUser && !isActive ? (
            <div className="gx-app-login-content">
              <Form
                initialValues={{ remember: true }}
                name="basic"
                onFinish={onFinishToken}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
                initialValues={{ isAccept: false }}
              >
                {" "}
                <FormItem
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد ارسال شده با وارد کنید",
                    },
                  ]}
                  name="Token"
                >
                  <Input placeholder="کد پیامک شده" />
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    فعال سازی
                  </Button>
                </FormItem>
              </Form>
              <span>در صورت هرگونه مشکل حداکثر تا 15 دقیقه دیگر مجددا امتحان کنید</span>
            </div>
          ) : (
            <div className="gx-app-login-content">
              <Form
                initialValues={{ remember: true }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem
                  rules={[
                    { required: true, message: "لطفا نام کاربری را وارد کنید" },
                  ]}
                  name="UserName"
                >
                  <Input placeholder="نام کاربری" />
                </FormItem>

                <FormItem
                  name="Password"
                  rules={[
                    { required: true, message: "لطفا کلمه عبور را وارد کنید" },
                  ]}
                >
                  <Input type="password" placeholder="کلمه عبور" />
                </FormItem>
                <FormItem
                  name="ConfirmPassword"
                  rules={[
                    { required: true, message: "لطفا مجددا کلمه عبور را وارد کنید" },
                  ]}
                >
                  <Input type="password" placeholder="تکرار کلمه عبور" />
                </FormItem>
                <FormItem
                  style={{ direction: "ltr" }}
                  initialValue="9"
                  name="MobileNumber"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شماره موبایل را وارد کنید",
                    },
                  ]}
                >
                  <PhoneInput disableDropdown={true} country={'ir'} onlyCountries={['ir']} disableCountryCode={true} placeholder="شماره موبایل" value="9" />
                </FormItem>
                <FormItem name="isAccept" valuePropName="checked">
                  <Checkbox>
                    <IntlMessages id="appModule.iAccept" />
                  </Checkbox>
                  {/* <span className="gx-signup-form-forgot gx-link">
                    <IntlMessages id="appModule.termAndCondition" />
                  </span> */}
                </FormItem>
                <FormItem name="IsAgent" valuePropName="checked">
                  <Checkbox
                    onChange={(e) => {
                      setAgent(e.target.checked);
                    }}
                    checked={isAgent == true ? "checked" : "unchecked"}
                  >
                    درخواست نمایندگی دارم
                  </Checkbox>
                </FormItem>
                {isAgent && (
                  <div>
                    <FormItem name="OfficeCode" rules={[
                      {
                        required: true,
                        message: "کد دفتر را وارد کنید",
                      },
                    ]}>

                      <Input placeholder="کد دفتر" />
                    </FormItem>
                    <FormItem name="PostalCode" rules={[
                      {
                        required: true,
                        message: "کد پستی را وارد کنید",
                      },
                    ]}>

                      <Input placeholder="کد پستی" />
                    </FormItem>
                    <FormItem name="Tel" rules={[
                      {
                        required: true,
                        message: "نلفن دفتر را وارد کنید",
                      },
                    ]}>

                      <Input placeholder="تلفن دفتر" />
                    </FormItem>
                    <FormItem name="ManagerName" rules={[
                      {
                        required: true,
                        message: "نام مدیر را وارد کنید",
                      },
                    ]}>

                      <Input placeholder="نام مدیر" />
                    </FormItem>
                    <FormItem name="State" rules={[
                      {
                        required: true,
                        message: " استان را وارد کنید",
                      },
                    ]}>

                      <Select
                        style={{ width: '100%' }}
                        onChange={handleStateChange}
                        placeholder="استان"

                        tokenSeparators={[',']}
                      >
                        {state}
                      </Select>
                    </FormItem>
                    <FormItem name="City" rules={[
                      {
                        required: true,
                        message: " شهر را وارد کنید",
                      },
                    ]}>

                      <Select
                        style={{ width: '100%' }}
                        onChange={handleCityChange}
                        placeholder="شهر"

                        tokenSeparators={[',']}
                      >
                        {city}
                      </Select>
                    </FormItem>
                    <FormItem name="Address" rules={[
                      {
                        required: true,
                        message: " آدرس را وارد کنید",
                      },
                    ]}>

                      <Input placeholder="آدرس" />
                    </FormItem>
                  </div>
                )}
                <ReCAPTCHA sitekey="Your client site key" />
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.signUp" />
                  </Button>
                  <Button ghost type="danger" ghost className="gx-mb-0" onClick={(e) => { props.history.push("/signin") }}>
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </FormItem>
              </Form>
            </div>
          )}
          {loader && (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignUp;
